"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedMenuItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const grouped_menu_content_styles_1 = require("./grouped-menu-content.styles");
const GroupedMenuItem = ({ group, parentId, selectedIds, isDisabled, isExpanded, onSelect, toggleExpand, }) => {
    const childIds = group.children.map((c) => c.value);
    const numSelected = childIds.filter((id) => selectedIds.includes(id)).length;
    const allSelected = numSelected === childIds.length && childIds.length > 0;
    const someSelected = numSelected > 0 && numSelected < childIds.length;
    const handleParentToggle = (0, react_1.useCallback)((_e, checked) => {
        childIds.forEach((childId) => onSelect(childId, checked));
    }, [childIds, onSelect]);
    return (react_1.default.createElement("li", null, react_1.default.createElement(grouped_menu_content_styles_1.StyledUl, null, react_1.default.createElement(grouped_menu_content_styles_1.StyledListSubheader, { disableSticky: false }, react_1.default.createElement("div", { className: "subheader-content" }, react_1.default.createElement(material_1.IconButton, { size: "small", onClick: () => toggleExpand(parentId), "aria-label": "toggle expand" }, react_1.default.createElement(ui_components_1.Icon, { variant: isExpanded ? 'chevronUp' : 'chevronDown' })), react_1.default.createElement(material_1.FormControlLabel, { label: group.label, control: react_1.default.createElement(material_1.Checkbox, { checked: allSelected, indeterminate: someSelected, disabled: isDisabled, onChange: handleParentToggle }) }))), isExpanded
        && group.children.map((child, childIndex) => {
            const isChecked = selectedIds.includes(child.value);
            return (react_1.default.createElement(grouped_menu_content_styles_1.StyledChildListItem, { key: `child-${childIndex}` }, react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { checked: isChecked, disabled: isDisabled, onChange: (_evt, checked) => onSelect(child.value, checked) }), label: react_1.default.createElement(material_1.Tooltip, { title: child.label, placement: "right" }, react_1.default.createElement("div", null, react_1.default.createElement(grouped_menu_content_styles_1.StyledListItemText, { primary: child.label }))) })));
        }))));
};
exports.GroupedMenuItem = GroupedMenuItem;
